// extracted by mini-css-extract-plugin
export var addCustomArrow = "AuctionDetail-module--add-custom-arrow--4ce3a";
export var addUnderlineLabel = "AuctionDetail-module--add-underline-label--5b305";
export var badgePageLink = "AuctionDetail-module--badge-page-link--5bc7a";
export var bgColor1 = "AuctionDetail-module--bg-color-1--04cae";
export var bgColor2 = "AuctionDetail-module--bg-color-2--c7d89";
export var bgColor3 = "AuctionDetail-module--bg-color-3--f21d1";
export var bidBox = "AuctionDetail-module--bid-box--24cf4";
export var bidList = "AuctionDetail-module--bid-list--faaec";
export var borderTextBox = "AuctionDetail-module--border-text-box--efacb";
export var borderTextRow = "AuctionDetail-module--border-text-row--b33e4";
export var breadcrumbContainer = "AuctionDetail-module--breadcrumb-container--980bb";
export var breadcrumbItem = "AuctionDetail-module--breadcrumb-item--e09c8";
export var bsPopoverAuto = "AuctionDetail-module--bs-popover-auto--0d51f";
export var bsPopoverBottom = "AuctionDetail-module--bs-popover-bottom--6b373";
export var bsPopoverEnd = "AuctionDetail-module--bs-popover-end--5d424";
export var bsPopoverStart = "AuctionDetail-module--bs-popover-start--4ea7b";
export var bsPopoverTop = "AuctionDetail-module--bs-popover-top--f968a";
export var btbBtn = "AuctionDetail-module--btb-btn--0409b";
export var btbButtonBox = "AuctionDetail-module--btb-button-box--51202";
export var btbButtonList = "AuctionDetail-module--btb-button-list--65406";
export var btbRight = "AuctionDetail-module--btb-right--801c7";
export var btbUserImg = "AuctionDetail-module--btb-user-img--62ce7";
export var btn = "AuctionDetail-module--btn--d034b";
export var btnButtonItem = "AuctionDetail-module--btn-button-item--c3bbc";
export var btnLg = "AuctionDetail-module--btn-lg--c2fe1";
export var btnUserLabel = "AuctionDetail-module--btn-user-label--697d6";
export var customMx2 = "AuctionDetail-module--custom-mx-2--ce63f";
export var customTooltip = "AuctionDetail-module--custom-tooltip--50024";
export var defaultPageLink = "AuctionDetail-module--default-page-link--bc76f";
export var dropdownMenu = "AuctionDetail-module--dropdown-menu--73cc0";
export var fwMedium = "AuctionDetail-module--fw-medium--f46ef";
export var loading = "AuctionDetail-module--loading--8b901";
export var lottiePlayerBox = "AuctionDetail-module--lottie-player-box--02149";
export var newBreadcrumbContainer = "AuctionDetail-module--new-breadcrumb-container--97b1f";
export var newTabList = "AuctionDetail-module--new-tab-list--dce71";
export var otherCardBox = "AuctionDetail-module--other-card-box--bc495";
export var otherCardImgBox = "AuctionDetail-module--other-card-img-box--11be6";
export var otherCardItem = "AuctionDetail-module--other-card-item--debb3";
export var otherCardList = "AuctionDetail-module--other-card-list--a9237";
export var otherCardListRow = "AuctionDetail-module--other-card-list-row--123c2";
export var otherCardSubtitle = "AuctionDetail-module--other-card-subtitle--5a8b3";
export var otherCardText = "AuctionDetail-module--other-card-text--5ea7e";
export var otherCardTitle = "AuctionDetail-module--other-card-title--61fee";
export var pdCtaBox = "AuctionDetail-module--pd-cta-box--69ef4";
export var pdCtaBtn = "AuctionDetail-module--pd-cta-btn--953f0";
export var pdCtaTextBox = "AuctionDetail-module--pd-cta-text-box--a68cb";
export var pdIntroBox = "AuctionDetail-module--pd-intro-box--fdcf3";
export var pdTextBox = "AuctionDetail-module--pd-text-box--f03b5";
export var playIcon = "AuctionDetail-module--play-icon--1c22c";
export var pltItem = "AuctionDetail-module--plt-item--6226c";
export var popoverArrow = "AuctionDetail-module--popover-arrow--5e5b3";
export var popoverBody = "AuctionDetail-module--popover-body--7da31";
export var ppoBox = "AuctionDetail-module--ppo-box--a2ee9";
export var ppoItem = "AuctionDetail-module--ppo-item--78c84";
export var prodStickyTop = "AuctionDetail-module--prod-sticky-top--d9f7b";
export var productDetailsBox = "AuctionDetail-module--product-details-box--1cd61";
export var productDetailsTable = "AuctionDetail-module--product-details-table--e43ad";
export var productImg = "AuctionDetail-module--product-img--a7a8c";
export var productImgBox = "AuctionDetail-module--product-img-box--a1c06";
export var productLoadingRow = "AuctionDetail-module--product-loading-row--0dafa";
export var productLoadingThumbnails = "AuctionDetail-module--product-loading-thumbnails--03f1c";
export var productPreviewOption = "AuctionDetail-module--product-preview-option--3f41b";
export var productSlider = "AuctionDetail-module--product-slider--d5152";
export var productSliderOuter = "AuctionDetail-module--product-slider-outer--39d2a";
export var productSliderRow = "AuctionDetail-module--product-slider-row--460f1";
export var productSpecificationTable = "AuctionDetail-module--product-specification-table--8d774";
export var productSpecificationtableOuter = "AuctionDetail-module--product-specificationtable-outer--e567d";
export var productThumbList = "AuctionDetail-module--product-thumb-list--2dd24";
export var ptImgBox = "AuctionDetail-module--pt-img-box--3b3b2";
export var ptItem = "AuctionDetail-module--pt-item--2eaa1";
export var rowIconBox = "AuctionDetail-module--row-icon-box--4561b";
export var rowIconItem = "AuctionDetail-module--row-icon-item--de4d5";
export var rowIconNotifyLabel = "AuctionDetail-module--row-icon-notify-label--66319";
export var seprator = "AuctionDetail-module--seprator--539a9";
export var share = "AuctionDetail-module--share--1cdff";
export var singleProductContainer = "AuctionDetail-module--single-product-container--cbc7e";
export var singleProductDetailsRow = "AuctionDetail-module--single-product-details-row--bc86a";
export var singleProductSiderbar = "AuctionDetail-module--single-product-siderbar--308cb";
export var singleProductSliderHeader = "AuctionDetail-module--single-product-slider-header--c7ad2";
export var singleProductSliderRow = "AuctionDetail-module--single-product-slider-row--4b983";
export var singleProductTextBox = "AuctionDetail-module--single-product-text-box--3a67b";
export var singleProductTop = "AuctionDetail-module--single-product-top--0ed15";
export var singleProductTopContainer = "AuctionDetail-module--single-product-top-container--607f6";
export var slickList = "AuctionDetail-module--slick-list--cb089";
export var slickNext = "AuctionDetail-module--slick-next--51702";
export var slickPrev = "AuctionDetail-module--slick-prev--701f7";
export var slickSlider = "AuctionDetail-module--slick-slider--e2b76";
export var smallDotList = "AuctionDetail-module--small-dot-list--61c8f";
export var socialLink = "AuctionDetail-module--social-link--a13c8";
export var socialLinkList = "AuctionDetail-module--social-link-list--11996";
export var spshLabel = "AuctionDetail-module--spsh-label--5a09e";
export var spsrButtonRow = "AuctionDetail-module--spsr-button-row--c93ba";
export var sptButton = "AuctionDetail-module--spt-button--34644";
export var sptRightTop = "AuctionDetail-module--spt-right-top--d6c63";
export var sptTextRow = "AuctionDetail-module--spt-text-row--ab062";
export var sptWidgetRow = "AuctionDetail-module--spt-widget-row--50940";
export var tableFixedHeight = "AuctionDetail-module--table-fixed-height--8e754";
export var tdTextBoxRow = "AuctionDetail-module--td-text-box-row--20410";
export var thumbnailsSlider = "AuctionDetail-module--thumbnails-slider--5236a";
export var underlineLabelTxt = "AuctionDetail-module--underline-label-txt--8b94d";
export var xsPadd = "AuctionDetail-module--xs-padd--c8879";
export var xsRowIconContainer = "AuctionDetail-module--xs-row-icon-container--92bb0";